import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 38, height: 39, viewBox: "0 0 38 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { y: 0.617188, width: 38, height: 38, rx: 19, fill: "#F1F1F1" }));
export default SvgCircle;
